module.exports = __webpack_public_path__ + "20d52c9de1720abde0863fd1fdc794cc.svg";